import { z } from "zod";
export const PromptGetParamsSchema = z.object({
    uiDescription: z
        .string()
        .optional()
        .describe("Brief plain-English summary of what guidance is being retrieved (shown in the UI dropdown)."),
    ids: z
        .array(z.string().min(1))
        .min(1)
        .describe("Prompt section IDs to retrieve (from promptSearch results)."),
});
